import sdl from '@jds/react-generated-sdl/JDSMegaMenu';
import type { JDSMegaMenuProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSMegaMenuProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { open = false, custom = '', ...rest } = props as any;
  return createComponent(
    json,
    { open, ...rest },
    'JDSMegaMenu',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const MegaMenu = withLogic(Component) as React.FC<JDSMegaMenuProps> & {
  slotName?: string;
};

MegaMenu.displayName = 'MegaMenu';
MegaMenu.slotName = 'jds_mega_menu';

export { MegaMenu, type JDSMegaMenuProps };
